import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.statistik-liste';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleStatistikListeEffects {

    StatistikListe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_STATISTIK_LISTE),
        mergeMap((x: ac.GetStatistikListeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getStatistikListe().pipe(
                map((result: any) => {
                    return new ac.GetStatistikListeErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetStatistikListeFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleSqlService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleSqlService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleSqlService);
        }
        return this.service;
    }
}
